<template>
	<div class="minigame">
		<Intro v-if="stageType == 'Intro'"/>
		<div class="minigame-content" v-else-if="stageType == 'Rounds'">

			<RoundIntro v-if="roundState == 'intro'"/>
			<Explanation v-else-if="roundState == 'explanation'" id="questions"/>
			<Feedback v-else-if="roundState == 'feedback'"/>



			<SimonSays v-else-if="roundType == 'simonsays'"></SimonSays>
			<SysteemDenken v-else-if="roundType == 'systeemdenken'"></SysteemDenken>
			<SysteemDenkenControleVragen v-else-if="roundType == 'systeemdenken_controlevragen'"></SysteemDenkenControleVragen>
			<SwipeQuiz v-else-if="roundType == 'swipequiz'"></SwipeQuiz>
			<ABQuiz v-else-if="roundType == 'abquiz'"/>
			<MultiQuiz v-else-if="roundType == 'multiquiz'"/>
			<MatchingQuiz v-else-if="roundType == 'matchingquiz'"/>
			<World v-else-if="roundType == 'worldquiz'"/>
			<LandMark v-else-if="roundType == 'landmark'"/>
			<ImpactCalculator v-else-if="roundType == 'impactcalculator'"/>
			<TeamRole v-else-if="roundType == 'teamrole'"/>
			<MbtiProfile v-else-if="roundType == 'mbtiprofile'"/>

		</div>
		<Totem v-else-if="stageType == 'Score'"/>
	</div>
</template>

<script>

	import ABQuiz from './minigames/abquiz/Index.vue';
	import MultiQuiz from './minigames/multiquiz/Index.vue';
	import MatchingQuiz from './minigames/matchingquiz/Index.vue';
	import SwipeQuiz from './minigames/swipequiz/Index.vue';
	import SysteemDenken from './minigames/systeemdenken/Index.vue';
	import SysteemDenkenControleVragen from './minigames/SysteemdenkenControleVragen/Index.vue';
	import SimonSays from './minigames/simonsays/Index.vue';
	import World from './minigames/world/Index.vue';
	import LandMark from './minigames/landmark/Index.vue';
	import ImpactCalculator from './minigames/impactcalculator/Index.vue';
	import TeamRole from './minigames/teamrole/Index.vue';
	import MbtiProfile from './minigames/mbtiprofile/Index.vue';

	import Intro from './minigames/Intro.vue';
	import RoundIntro from './minigames/RoundIntro.vue';
	import Explanation from './minigames/Explanation.vue';
	import Totem from './minigames/Totem.vue';
	import Feedback from './minigames/feedback/Index.vue';
	import { mapGetters , mapActions } from 'vuex';

	export default {

		components:{
			Intro,
			RoundIntro,
			Explanation,
			Totem,
			Feedback,
			ABQuiz,
			MultiQuiz,
			MatchingQuiz,
			SwipeQuiz,
			SysteemDenken,
			SysteemDenkenControleVragen,
			SimonSays,
			World,
			LandMark,
			ImpactCalculator,
			TeamRole,
			MbtiProfile
		},

		computed: {
			...mapGetters(["roundState","blockType","stageType","roundCompleted","roundExplained","roundType"]),
		},


		methods:{
			...mapActions([]),
		}

	}
</script>


// WEBPACK FOOTER //
// src/components/Minigame.vue